import { Button, ButtonGroup, Form } from "react-bootstrap"
import TenkosyaInfo from "../../../../components/Tablet/TenkosyaInfo"
import dateUtil from "../../../../ts/util/dateUtil"
import { useCallback, useEffect, useRef, useState } from "react"
import BusyoService from "../../../../service/master/busyo/busyoService"
import { T部所マスタ } from "../../../Order/UnsogyomuHatyusyo/UnsogyomuHatyusyo"
import { useSelector } from "react-redux"
import { RootState } from "../../../../globalStore/rootreducer"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import BackButton from "../../../../components/Tablet/BackButton"
import { タブレット用点呼情報 } from "../../../../service/tablet/TTabletTenko"
import TabletTenkoService from "../../../../service/tablet/tabletTenkoService"
import TenkoListGrid from "./TenkoListGrid"

const FORM_NAME_点呼日 = "点呼日"
const FORM_NAME_部所コード = "部所コード"

const TenkoList = () => {
  const 初期営業日 = dateUtil.format(new Date(), "YYYY-MM-DD")
  const 初期部所コード = useSelector(
    (root: RootState) => root.user.LoginUserInfo.部所コード
  )

  const formRef = useRef<HTMLFormElement>(null)
  const [gridFontSize, setGridFontSize] = useState<
    (typeof CSS_PROPERTY.GRID_FONT_SIZE)[keyof typeof CSS_PROPERTY.GRID_FONT_SIZE]
  >(CSS_PROPERTY.GRID_FONT_SIZE.中)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [運行有フラグ, set運行有フラグ] = useState(true)
  const [isSearching, setIsSearching] = useState(true)

  const [全点呼List, set全点呼List] = useState<タブレット用点呼情報[]>()
  const [表示点呼List, set表示点呼List] = useState<タブレット用点呼情報[]>()
  const [点呼日, set点呼日] = useState<string>("")

  const search = useCallback(async () => {
    setIsSearching(true)
    set全点呼List(undefined)
    set表示点呼List(undefined)
    const formData = formRef.current ? new FormData(formRef.current) : null

    if (!formData) return

    const 点呼日: string =
      (formData.get(FORM_NAME_点呼日) as string) ?? 初期営業日
    const 部所コード: string =
      (formData.get(FORM_NAME_部所コード) as string) ?? 初期部所コード

    try {
      const res = await new TabletTenkoService().getList({
        点呼日,
        部所コード,
      })
      if (res.data) {
        set全点呼List(res.data)
        set点呼日(点呼日)
      }
    } catch (error) {
      //TODO:メッセージの出し方調整
    } finally {
      setIsSearching(false)
    }
  }, [初期営業日, 初期部所コード])

  // 初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(
      async ([部所ListRes]) => {
        set部所ItemSource(
          部所ListRes.data.filter((data) => data.運行部所フラグ === 1)
        )
        // 画面表示時に検索を行う
        await search()
      }
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (全点呼List == null) return
    set表示点呼List(
      運行有フラグ ? 全点呼List.filter((d) => d.運行数 > 0) : 全点呼List
    )
  }, [全点呼List, 運行有フラグ])

  return (
    <>
      <TenkosyaInfo>
        <Form ref={formRef}>
          <table className="w-100" style={{ tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td style={{ width: "30%" }}>
                  <Form.Group style={{ color: "black" }}>
                    <Form.Label style={{ fontSize: "1.5rem" }}>
                      点呼日
                    </Form.Label>
                    <Form.Control
                      name={FORM_NAME_点呼日}
                      defaultValue={初期営業日}
                      disabled={isSearching}
                      onChange={search}
                      style={{
                        fontSize: "2rem",
                        padding: "0.375rem 0.75rem 0.225rem 0.75rem",
                      }}
                      type="date"
                    />
                  </Form.Group>
                </td>
                <td style={{ width: "40%" }}>
                  <Form.Group>
                    <Form.Label style={{ fontSize: "1.5rem" }}>部所</Form.Label>
                    {部所ItemSource && (
                      <Form.Select
                        name={FORM_NAME_部所コード}
                        onChange={search}
                        disabled={isSearching}
                        style={{ fontSize: "2rem" }}
                        defaultValue={初期部所コード}>
                        {部所ItemSource.map((部所) => (
                          <option key={部所.部所ID} value={部所.部所コード}>
                            {部所.部所コード} : {部所.部所略称}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  </Form.Group>
                </td>
                <td
                  className="align-bottom text-center"
                  style={{ width: "30%" }}>
                  <ButtonGroup>
                    <Button
                      variant={運行有フラグ ? "canceled" : "outline-canceled"}
                      disabled={isSearching}
                      type="button"
                      style={{
                        width: "8rem",
                        fontSize: "1.5rem",
                        height: "fit-content",
                      }}
                      onTouchStart={(e) => {
                        set運行有フラグ(true)
                      }}>
                      運行有
                    </Button>
                    <Button
                      variant={!運行有フラグ ? "canceled" : "outline-canceled"}
                      disabled={isSearching}
                      type="button"
                      style={{
                        width: "8rem",
                        fontSize: "1.5rem",
                        height: "fit-content",
                      }}
                      onTouchStart={(e) => {
                        set運行有フラグ(false)
                      }}>
                      全て
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            </tbody>
          </table>
        </Form>
      </TenkosyaInfo>
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td
              colSpan={2}
              style={{ height: CSS_PROPERTY.BODY_TABLE_BODY_ROW_HEIGHT }}>
              <div
                style={{ width: "100%", height: "100%", position: "relative" }}>
                {表示点呼List ? (
                  <TenkoListGrid
                    tenkoBi={点呼日}
                    tenkoList={表示点呼List}
                    fontSize={gridFontSize}
                  />
                ) : (
                  <div
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
                    className={
                      isSearching ? "spinner  fade is-show" : "spinner  fade"
                    }></div>
                )}
              </div>
            </td>
          </tr>
          <tr style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
            <td className="align-bottom">
              <BackButton />
            </td>
            <td className="align-bottom text-end">
              <ButtonGroup>
                {Object.keys(CSS_PROPERTY.GRID_FONT_SIZE).map((key) => {
                  const value =
                    CSS_PROPERTY.GRID_FONT_SIZE[
                      key as keyof typeof CSS_PROPERTY.GRID_FONT_SIZE
                    ]
                  return (
                    <Button
                      variant={
                        gridFontSize === value ? "canceled" : "outline-canceled"
                      }
                      disabled={isSearching}
                      type="button"
                      style={{
                        fontSize: value,
                        height: "3rem",
                      }}
                      onTouchStart={(e) => {
                        setGridFontSize(value)
                      }}>
                      {key}
                    </Button>
                  )
                })}
              </ButtonGroup>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default TenkoList
